import { render } from "./RequestLogDataTable.vue?vue&type=template&id=3bef54f9"
import script from "./RequestLogDataTable.vue?vue&type=script&lang=js"
export * from "./RequestLogDataTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__